import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './styles';
import { OpenInNew } from '@mui/icons-material';
import radarBg from '../../../../Assets/images/radar.svg';
import P47 from '../../../../Assets/Icons/P47logo.svg';
import Ideabaaz from '../../../../Assets/images/ideabaaz.svg';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import zIndex from '@mui/material/styles/zIndex';

const WhatToExpect = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const features = [
    'A growing founder community',
    'Mentorship from experts',
    "A national spotlight that doesn't switch off after your pitch",
    'Investors, CXOs, and ecosystem leaders who believe in your growth',
  ];

  const pitchOptions = [
    { logo: Ideabaaz, title: 'Pitch a <strong>Startup </strong>', onClick: () => navigate('/signup?applicationName=ideaBaaz') },
    // { logo: P47, title: 'Pitch <strong>Deep Tech</strong>', onClick: () => window.open('https://project47.ideabaaz.co.in/login') },
    { title: 'Pitch an <strong>Idea</strong>', onClick: () => window.open('https://www.ideabaazdangal.com/register') },
  ];

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Box className={classes.topLine} />
        <Box className={classes.textContainer}>
          <Typography variant="h1" className={classes.heading}>
            One platform.
          </Typography>
          <Typography variant="h1" className={classes.heading}>
            Endless possibilities.
          </Typography>
          <Typography className={classes.subtext}>
            Being on air is only the beginning. <br />
            Your story doesn't end with one pitch.
          </Typography>
        </Box>
        <Grid container spacing={isMobile ? 0 : 4} className={classes.gridContainer}>
          {features.map((item, index) => (
            <Grid item xs={12} sm={6} key={index} style={{}}>
              <Typography variant="h2" className={classes.featureBox}>
                {item}
              </Typography>
            </Grid>
          ))}
        </Grid>

        <Box
          component="img"
          src={Ideabaaz}
          alt="IdeaBaaz logo"
          sx={{
            position: 'relative', // so zIndex actually does something
            zIndex: 10, // bump it above your radar
            width: 100, // or '100%', or whatever fits
            height: 'auto', // maintain aspect ratio
            mx: 'auto', // center it horizontally
            display: 'block', // ensure it isn’t inline‐collapsed
            marginBottom: '20px',
          }}
        />

        <Box className={classes.button}>
          {pitchOptions.map((item, index) => (
            <Box key={index} className={`${classes.Container} ${isMobile ? (index === 2 ? classes.fullWidthMobile : classes.halfWidthMobile) : ''}`} onClick={item?.onClick}>
              <Box className={classes.logo}>
                <Typography className={classes.Label} dangerouslySetInnerHTML={{ __html: item.title }} />
              </Box>
              <OpenInNew className={classes.IconArrow} />
            </Box>
          ))}
        </Box>

        <img src={radarBg} alt="radar background" className={classes.radarImage} />
      </Box>
    </Box>
  );
};

export default WhatToExpect;
